import { Component } from '@angular/core';
import { ButtonDirective, ButtonLabel } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Ripple } from 'primeng/ripple';

@Component({
  selector: 'au-insurance-error',
  imports: [ButtonDirective, Ripple, ButtonLabel],
  templateUrl: './insurance-error.component.html',
  styleUrls: ['./insurance-error.component.scss'],
})
export class InsuranceErrorComponent {
  data: any;
  secondaryButtonText = 'Return to Shipment';
  showContinueButton = true;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.data = config.data;
    this.secondaryButtonText =
      config.data?.secondaryButtonText || this.secondaryButtonText;
    this.showContinueButton = config.data?.showContinueButton !== false;
  }

  onReturnToShipment(): void {
    this.ref.close('RETURN_TO_SHIPMENT');
  }

  onContinueWithoutOption(): void {
    this.ref.close('CONTINUE_WITHOUT_OPTION');
  }
}
